import {
  LayoutDashboard,
  Building2,
  TrendingUp,
  BarChart3,
  ClipboardList,
  FileText,
  Users,
  Settings,
  Upload,
  HeartHandshake,
  LucideChartColumn,
  Wallet,
  LucideMap,
  HelpCircle,
  GraduationCap,
} from "lucide-react";
import { ROLES } from "../../constants/roles";

/*
 * Per-role sidebar navigation configs.
 * --------------------------------------
 * Each entry: { to, label, icon }.
 * Items grouped via `section` so the sidebar can render a separator between
 * the "main" links and "admin-only" links without per-role conditional JSX.
 *
 * Keeping the data here means the Sidebar component stays presentational and
 * we can add/remove links by editing one place.
 */

// Admin navigation with all pages including system admin pages.
const adminNav = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/ventures", label: "Ventures", icon: Building2 },
  { to: "/admin/impact", label: "Impact & Outcomes", icon: TrendingUp },
  { to: "/admin/portfolio", label: "Portfolio Performance", icon: BarChart3 },
  {
    to: "/admin/data-collection",
    label: "Data Collection",
    icon: ClipboardList,
  },
  { to: "/admin/training", label: "Training", icon: GraduationCap },
  { to: "/admin/reports", label: "Reports & Learning", icon: FileText },
];

// Admin-only system links (User Management, Settings).
const adminSystemNav = [
  { to: "/admin/users", label: "User Management", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

// Manager navigation (without system admin pages).
const managerNav = [
  { to: "/manager/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/manager/ventures", label: "Ventures", icon: Building2 },
  { to: "/manager/impact", label: "Impact & Outcomes", icon: TrendingUp },
  { to: "/manager/portfolio", label: "Portfolio Performance", icon: BarChart3 },
  {
    to: "/manager/data-collection",
    label: "Data Collection",
    icon: ClipboardList,
  },
  { to: "/manager/training", label: "Training", icon: GraduationCap },
  { to: "/manager/reports", label: "Reports & Learning", icon: FileText },
];

const funderNav = [
  {
    to: "/funder/dashboard",
    label: "Dashboard",
    icon: LucideChartColumn,
    end: true,
  },
  { to: "/funder/impact", label: "Impact Overview", icon: TrendingUp },
  { to: "/funder/financial", label: "Financial Accountability", icon: Wallet },
  { to: "/funder/programs", label: "Program Views", icon: LucideMap },
  { to: "/funder/reports", label: "Reports", icon: FileText },
];

const ventureNav = [
  {
    to: "/venture/dashboard",
    label: "My Dashboard",
    icon: LayoutDashboard,
    end: true,
  },
  {
    to: "/venture/support",
    label: "Support & Resources",
    icon: HeartHandshake,
  },
];

/*
 * Returns the nav sections for a given role. A "section" is just a group of
 * items that should be visually separated from the next group in the sidebar.
 */
export function getNavSectionsForRole(role) {
  switch (role) {
    case ROLES.ADMIN:
      return [adminNav, adminSystemNav];
    case ROLES.MANAGER:
      return [managerNav];
    case ROLES.FUNDER:
      return [funderNav];
    case ROLES.VENTURE:
      return [ventureNav];
    default:
      return [];
  }
}
